import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {FIELD_LIST_INPUT_MAIN_BANNER_LOYALTY_PROGRAM} from "../../utils/input-field-list-static-page";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import React, {useEffect} from "react";
import FormGeneralComponent from "../../components/static-page/form-general.component";
import {setLoyaltyProgramErrorMessage, setLoyaltyProgramMainBannerDetail} from "../../reducers/loyalty-program.reducer";

const MainBanner = () => {
    const dispatch = useDispatch()
    const {mainBannerDetail, loyaltyProgramErrorMessage} = useSelector(state => state.loyaltyProgramReducer)
    const {fetching: getMainBanner} = useFetch(API.LOYALTY_PROGRAM_GET_MAIN_BANNER)
    const {fetching: updateMainBanner, isLoading} = useFetch(API.LOYALTY_PROGRAM_UPDATE_MAIN_BANNER)
    let fieldListInput = FIELD_LIST_INPUT_MAIN_BANNER_LOYALTY_PROGRAM
    let showMainBanner = {
        label: 'Main Banner',
        key: 'show_main_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setLoyaltyProgramMainBannerDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateMainBanner(mainBannerDetail).then(response => {
            dispatch(setLoyaltyProgramErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Main Banner Updated'))
            dispatch(setLoyaltyProgramMainBannerDetail(response?.data))
        }).catch(err => {
            dispatch(setLoyaltyProgramErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getMainBanner().then(response => {
            dispatch(setLoyaltyProgramMainBannerDetail(response?.data))
        })

        return () => {
            dispatch(setLoyaltyProgramErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={mainBannerDetail}
            switchToggleField={showMainBanner}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={loyaltyProgramErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default MainBanner
